import { JSX, useState } from 'react';
import {
    Box,
    Button,
    CircularProgress,
} from '@mui/material';
import { useRecordContext } from 'react-admin';
import { Customer } from "../../../../types/entities";
import { useCustomerPasswordResetSender } from "./hooks/customer-password-reset";

export const CustomerPasswordReset: () => JSX.Element = (): JSX.Element => {
    const { sendingEmail, errorMessage, successMessage, sendEmail } = useCustomerPasswordResetSender();
    const record: Customer = useRecordContext();

    function handleSendingEmail(): void {
        if (record) {
            sendEmail(record.email);
        }
    }

    return (
        <Box sx={ { width: '60%', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' } }>
            { (successMessage !== undefined) &&
                <span style={ { color: '#5ce30d' } } >{ successMessage }</span>
            }
            { (errorMessage !== undefined) &&
                <span style={ { color: '#ef1b04' } } >{ errorMessage }</span>
            }
            <Button variant="contained" onClick={ handleSendingEmail }>
                { sendingEmail &&
                    <CircularProgress sx={ { width: '25px', height: '25px', marginRight: '10px' } } color="secondary" />
                }
                { "Send Reset Email" }
            </Button>
        </Box>
    );
}